import React from 'react';
import './App.css';
import './SearchInput.css';
import SearchInputField from './SearchInputField';
import SearchInputList from './SearchInputList';
// import RandomButton from './RandomButton';

class SearchInput extends React.Component {
  state = {
    selectedPersonID: '',
    searchValue: '',
    searchResultsVisible: false,
    searchResults: [],
    isSearching: false
  };

  onSelectSearchInput = (position, personID, personName, _searchResultsVisible=false, _searchResults=[]) => {
    this.setState({ 
      selectedPersonID: personID,
      searchValue: personName,
      searchResultsVisible: _searchResultsVisible,
      searchResults: _searchResults  // Clear out search results on user selection unless passed in, probably from random button
     });

     // Bubble the selected search input and position up to the parent component
     this.props.onSearchInputSelected(position, personID, personName);
  };


  debounceTimer = null;
  abortController = null;

  onChange = (event) => {
    const newValue = event.target.value;
    this.setState({ searchValue: newValue });
    this.props.onSearchInputChange(this.props.position);

    // Cancel any pending debounce timer and in-flight fetch
    clearTimeout(this.debounceTimer);
    if (this.abortController) {
      this.abortController.abort();
    }

    // Only initiate a search if the user inputs three or more characters
    if (newValue.trim().replaceAll(" ","").length >= 3) {
      this.setState({ searchResultsVisible: true, searchResults: [] }); // Clear previous search results immediately when a new search is initiated
      this.debounceTimer = setTimeout(() => {
        this.abortController = new AbortController();
        this.setState({ isSearching: true });
        const fetchString = `${process.env.REACT_APP_API_BASE_URL}/api/personbyname?searchName=${newValue}&numResults=10`;
        fetch(fetchString, { signal: this.abortController.signal })
          .then(response => response.json())
          .then(data => this.setState({ searchResults: data, isSearching: false }))
          .catch(err => {
            if (err.name !== 'AbortError') {
              this.setState({ isSearching: false });
              throw err;
            }
          });
      }, 750); // Wait 0.75 sec after user stops typing befor initiating search
    } else {
      this.setState({ searchResultsVisible: false, isSearching: false });
    }
  };

  onBlur = () => {
    // Hide search results when the input loses focus, this also triggers when a search result is selected, so we need to delay hiding the results to allow the click event to register
    setTimeout(() => {
      this.setState({ searchResultsVisible: false });
    }, 200);
  }

  onRandomButtonClick = () => {
    // console.log(`${this.props.position}: Random button clicked`);

    this.setState({ searchResultsVisible: true, searchResults: [] }); // Clear previous search results immediately when the random button is clicked
    
    // Cancel any pending debounce timer and in-flight fetch
    clearTimeout(this.debounceTimer);
    if (this.abortController) {
      this.abortController.abort();
    }

    // Call the API to get a random SearchInputList and select the first result
    const fetchString = `${process.env.REACT_APP_API_BASE_URL}/api/RandomActors?&NumResults=10&MinPTile=20`;
    fetch(fetchString)
          .then(response => response.json())
          .then(data => { // Automatically select the first result from the random search results
            this.setState({ searchResults: data, isSearching: false });
            this.onSelectSearchInput(this.props.position, data[0].PersonID, data[0].PersonName, true, data);
          })
          .catch(err => {
            if (err.name !== 'AbortError') {
              console.WriteLine(`${this.props.position}: Error fetching random actors: `, err);
              this.setState({ searchResults: [],isSearching: false });
              throw err;
            }
          });
    
  }

  render() {
    // console.log('Test search results: ', this.props.position, testSearchResults);
    const cssClasses = this.props.position + '-search-input search-input';
    return (
      <span className={cssClasses}>
        <div className="search-input-row">
          <SearchInputField searchValue={this.state.searchValue}
                            onChange={this.onChange}
                            position={this.props.position}
                            onBlur={this.onBlur} 
                            siteStatus={this.props.siteStatus} 
                            // RandomButton props:
                            onRandomButtonClick={this.onRandomButtonClick}
                            disabled={this.props.siteStatus !== "Up"}
                            />
        </div>
        <SearchInputList searchValue={this.state.searchValue}
                         searchResultsVisible={this.state.searchResultsVisible}
                         position={this.props.position}
                         searchResults={this.state.searchResults}
                         isSearching={this.state.isSearching}
                         onSelectSearchInput={this.onSelectSearchInput} />
      </span>
    );
  }
}

export default SearchInput;